import { defineStore } from 'pinia'

export type HelpFeedbackType = 'bug' | 'suggestion'

const HELP_CHAT_OPENED_KEY = 'helpChat-opened'

export const useHelpChatStore = defineStore('helpChat', {
  state: () => ({
    isOpen: false,
    hasBeenOpened: localStorage.getItem(HELP_CHAT_OPENED_KEY) === 'true',
    pendingSuggestionPrefill: null as string | null,
  }),

  actions: {
    open() {
      this.isOpen = true
      if (!this.hasBeenOpened) {
        this.hasBeenOpened = true
        localStorage.setItem(HELP_CHAT_OPENED_KEY, 'true')
      }
    },

    close() {
      this.isOpen = false
      this.pendingSuggestionPrefill = null
    },

    toggle() {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    },

    /**
     * Opens help chat already in suggestion mode with a draft message.
     */
    openSuggestion(prefillMessage: string) {
      this.pendingSuggestionPrefill = prefillMessage
      if (this.isOpen) {
        // Force HelpChat watcher to re-run when already open
        this.isOpen = false
        queueMicrotask(() => {
          this.open()
        })
        return
      }
      this.open()
    },

    consumeSuggestionPrefill(): string | null {
      const message = this.pendingSuggestionPrefill
      this.pendingSuggestionPrefill = null
      return message
    },
  },
})
